import {createActions} from 'client/framework';

const normalActions = ['APPLY_SORT'];

export default createActions(null, normalActions);
